export default {
  // labels
  'label.register_title1': 'Sign up',
  'label.register_title2': 'Make payments and transfers',
  'label.register_title3': 'Manage favorites',
  'label.register_description1': 'Register with just a phone number and make commission-free payments.',
  'label.register_description2': 'Make payments and transfers in 17 categories with 1000+ services, also benefit from transfers with numbers and cards.',
  'label.register_description3': 'Enhance selected payments, manage automatic payments and debts, take advantage of NFC services.',
  'label.auth.least_symbol': 'At least 8 characters',
  'label.auth.most_symbol': 'Maximum 30 characters',
  'label.auth.min_max_symbols': 'Minimum 8, maximum 30 characters',
  'label.auth.uppercase': 'Minimum 1 uppercase letter',
  'label.auth.lowercase': 'Lowercase letters',
  'label.auth.number': 'Minimum 1 number',
  'label.auth.character': '1 special character: (@=$%)(#^&)]]',
  'label.register_error.whitespace': 'Do not leave blank',
  'label.register_error.match': 'The password does not match',
  'label.login_title': 'Fast, reliable, {easy}',
  'label.login_title.emanat': 'Fast, reliable and {easy}',
  'label.cobrand.alert': 'To complete the MPAY card order, you must verify your identity with SIMA {sima}.',
  'label.login_description': 'Log in or register to carry out payments and transfers for thousands of services within seconds.',
  'label.login_description_new': 'Make payments and transfers for thousands of services with one tap, instantly and securely.',
  'label.phone_number': 'Phone number',
  'label.password': 'Password',
  'label.old_password': 'Old password',
  'label.new_password': 'New password',
  'label.confirm_password': 'Confirm password',
  'label.remember': 'Remember',
  'label.dashboard': 'Dashboard',
  'label.favorites.added': 'Added to Favorites',
  'label.favorites.added.desc': 'The payment has been successfully added to favorites. You can view the all favorites from the right panel.',
  'label.favorites': 'Favorites',
  'label.favorites.search': 'Search in Favorites',
  'label.favorites.card': 'You are in Favorites',
  'label.autoPayment.card': 'You are in auto-payments!',
  'label.favorites.description': 'Make your payments and transfers faster by increasing favorite transactions.',
  'label.autoPayment.description': 'By creating auto-payments, you can make your payments automatically without delay.',
  'label.favorites.not_found.title': 'No Favorite found',
  'label.favorites.not_found.description': 'Make your payments and transfers faster by increasing favorite transactions.',
  'label.favorites.delete.description': 'When you delete a Favorite, the auto-payments associated with it will also be deleted.',
  'label.automobiles.delete.description': 'The vehicle with number {automobile} will be deleted',

  'label.switch.heading': 'Someone has logged into your account',
  'label.switch.description': 'If this is not you, choose one of the following for security.',
  'label.payment_info': 'Payment information',

  'label.autopayment': 'Auto payments',
  'label.autopayment.new': 'New',
  'label.autopayment.empty': 'No auto-payments found',
  'label.autopayment.search.empty': 'No automatic payment found matching your search.',
  'label.autopayment.create': 'Create auto-payments',
  'label.autopayment.choose.favorite': 'Mövcud seçilmişlərdən seç',
  'label.autopayment.monthly': 'Monthly',
  'label.autopayment.debt': 'based on the debt',
  'label.autopayment.schedule': 'according to the schedule',
  'label.autopayment.once': 'One time',

  'label.limits': 'Limits',

  'label.faq.title': 'How can we help you?',
  'label.faq.contact.title': 'Contact link',
  'label.faq.address': 'Albert Aqarunov St. 7B, AZ1075 Baku, Azerbaijan',

  'label.add.favorite': 'Add to Favorites',
  'label.added.favorite': 'Added to favorites',
  'label.added.description': 'Favorite has been created successfully. You can view payment in Favorites from the list.',
  'label.new.favorite': 'New favorite',
  'label.new.payment': 'New payment',
  'label.choose.operation': 'Choose payment',
  'label.choose_from_list': 'Select from the list',
  'label.create.favorite': 'Create favorite',
  'label.new.create.favorite': 'Create a new favorite',
  'label.history.subTitle': 'Terminal payment',
  'label.info.popup.title': 'Card information',
  'label.requisite.popup.title': 'Account requisite',
  'label.cobrand.history.title': 'MPAY card history',
  'label.my.cards': 'My Cards',
  'label.cards': 'Cards',
  'label.card.order': 'Card order',
  'label.card.order.success.title': 'The card has been ordered',
  'label.card.order.success.desc': 'Please bring your ID with you when you approach the branch.',
  'label.saved.cards': 'My saved cards',
  'label.card.order.title': 'MPAY card order',
  'label.card.order.detail.title': 'Pay on time, this time with a card!',
  'label.card.order.desc': 'We continue to facilitate cashless payments. Get your MPAY card now for free, make payments quickly and safely.',
  'label.card.order.detail.desc': 'We continue to simplify the process at the time of payment with the MPAY card as well. Order now for secure payments and many benefits.',
  'label.panels.header1': 'How can I get the card?',
  'label.panels.header2': 'How can I increase my card balance?',
  'label.panels.header3': 'How do I set or change my PIN?',
  'label.panels.header4': 'What is the annual income on the card account balance?',
  'label.panels.content1': "You can order the card online. After ordering, you will receive information about the card preparation process via SMS. And when it's ready, you can pick it up at the branch of your choice.",
  'label.panels.content2': 'It is possible to increase the card balance through payment terminals.',
  'label.panels.content3': 'You can set or change the PIN code through the "MPAY" application.',
  'label.panels.content4': 'The annual balance on the card account is set at X%.',
  'label.advantages.title1': 'Free cashout',
  'label.advantages.title2': 'Free card-to-card transactions',
  'label.advantages.title3': 'Free PIN setting and changing',
  'label.advantages.title4': 'Fee deposit to card',
  'label.advantages.title5': 'Notification by application and SMS',
  'label.advantages.title6': 'X% annual income on the balance of the AZN card account',
  'label.advantages.desc1': 'You can take advantage of free withdrawals 5 times a month at all ATMs in the country.',
  'label.advantages.desc2': 'You can transfer between MPAY cards. 0.5% commission is applied to domestic bank cards.',
  'label.advantages.desc3': 'You can set and change a new PIN easily and free of charge in the MPAY app.',
  'label.advantages.desc4': 'You can deposit to your account from the terminals, as well as from the MPAY wallet, without any additional fees.',
  'label.advantages.desc5': 'Enjoy the advantage of tracking transactions through the app and being notified via SMS.',
  'label.advantages.desc6': 'The interest amount calculated during the month will be transferred to the card account on the last working day of each month.',
  'label.card.tabLink1': 'About card',
  'label.card.tabLink2': 'Benefits',
  'label.card.tabLink3': 'More details',
  'label.card.type': 'Card type',
  'label.order.date': ' Order archive',
  'label.status': 'Status',
  'label.cobrand.settings.title': 'MPAY card parameters',
  'label.cardholder.name': 'Cardholder name',
  'label.card.number': 'Card number',
  'label.expiry.date': 'Expiry date',
  'label.card.info.popup.desc': 'This card is a co-branded product of MPAY and Rabita Bank.',
  'label.rename.title': 'Rename',
  'label.my.mpay.card': 'My MPAY card',
  'label.mpay.card': 'MPAY card',
  'label.recipient.name': "Recipient's name",
  'label.buyer.account': "Recipient's account",
  'label.receiving.bank': 'Receiving bank',
  'label.swift': 'SWIFT',
  'label.vöen': 'TIN',
  'label.bank.code': 'Bank code',
  'label.reporter.account': 'Correspondent account',
  'label.blocked': 'The card is blocked',
  'label.block.card.title': 'Block the card',
  'label.block.card.desc': 'If you block the card, it will not be possible to make transactions with the card. You can unblock the card whenever you want.',
  'label.unblock.card.title': 'Unblock the card',
  'label.unblock.card.desc': 'After unblocking the card, you can start transactions again.',
  'label.reset.pin.title': 'Reset PIN attempts',
  'label.reset.pin.desc': 'Get 3 more attempts.',
  'label.transfer.amount': 'Transfer amount',
  'label.transfer.source': 'Transfer source',
  'label.phone.number': 'Mobile number',
  'label.branch.delivery': 'Branch for delivery',
  'label.secret.word': 'Secret word',
  'label.card.order.status': 'You have an ordered MPAY card request.',
  'label.pin.code': 'PIN code',
  'label.fill.information.order': 'Fill in the information for the order',
  'label.card.benefits': 'Benefits of the card',
  'label.how.get.card': 'How can I get the card?',
  'label.fill.form': 'Fill out the form',
  'label.follow.notification': 'Follow the SMS notification',
  'label.get.card': 'Get the card',
  'label.annual.service.fee': 'Annual service fee',
  'label.free': '0 AZN',
  'label.duration': 'Duration',
  'label.years': '5 years',
  'label.currency': 'Currency',
  'label.cashback': 'Cashback',
  'label.percent': 'up to 40%',

  'label.payments': 'Payments',
  'label.transfers': 'Transfers',
  'label.coupons': 'My coupons',
  'label.transfer': 'Transfer',
  'label.debts': 'My debts',
  'label.transfers.wallet': 'Wallet transfer',
  'label.top-up': 'Top-up',
  'label.card_transfer': 'Transfer from card',
  'label.wallet_transfer': 'Transfer from MPAY wallet',
  'label.payment_source': 'Payment source',
  'label.payment_amount': 'Payment amount',
  'label.target_card': 'Target card',
  'label.share.receipt': 'Share receipt',
  'label.call.center.title': 'Click for contact info',
  'label.personal_info': 'Personal information',
  'label.select_language': 'Select language',
  'label.notifications': 'Notifications',
  'label.terms_conditions': 'Terms and Conditions',
  'label.read_all': 'Mark as read',
  'label.name_surname': 'First name, last name',
  'label.name': 'First name',
  'label.surname': 'Lat name',
  'label.father_name': 'Father\'s name',
  'label.full_name': 'Name, Surname, Father name',
  'label.pin': 'PIN',
  'label.date_of_birth': 'Date of birth',
  'label.gender': 'Gender',
  'label.language': 'Language',
  'label.settings': 'Settings',
  'label.history': 'History',
  'label.automobiles': 'Automobiles',
  'label.support': 'Support',
  'label.wallet': 'Wallet',
  'label.old.wallet': 'Previous MPAY wallet',
  'label.old.balance': 'My previous MPAY balance',
  'label.card': 'Card',
  'label.terminal': 'Terminal',
  'label.last_operations': 'Last operations',
  'label.frequently_used': 'Frequently used',
  'label.categories': 'Categories',
  'label.no_comission': 'No commission',
  'label.comission': '{amount} AZN commission will be added to this amount',
  'label.receipt.failed.operation': 'Failed operation',
  'label.receipt.failed.payment': 'Unsuccessful payment',
  'label.receipt.failed.transfer': 'Unsuccessful transfer',
  'label.receipt.inprogress.payment': 'Payment in progress',
  'label.receipt.inprogress.transfer': 'Transfer is in progress',
  'label.transfer.receipt.success': 'Transfer completed',
  'label.transfer_target.receipt.success': 'Transfer accepted',
  'label.general.receipt.success': 'Payment completed',
  'label.success': 'Successful',
  'label.success.card.name': 'The card name was successfully changed.',
  'label.success.card.delete': 'Card data is no longer available.',
  'label.pending': 'In progress',
  'label.fail': 'Unsuccessful',
  'label.approved': 'Approved',
  'label.receipt': 'Receipt',
  'label.other_operators': 'Other Operators',
  'label.mno': 'Add phone number',
  'label.pay_with_new_card': 'Pay with a new card',
  'label.saved_cards': 'Saved Cards',
  'label.service.debt.amount': '{serviceName} debt amount:',
  'label.service.balance.amount': '{serviceName} balance:',
  'label.switch.success_logout': 'Logged out',
  'label.coupon.coming': 'A gift balance for you',
  'label.coupon.sent': 'Gift balance sent',
  'label.coupon.sender.gift': 'Gift sender',
  'label.coupon.pending.title': 'Gift balance pending',
  'label.coupon.pending.status': 'Pending',
  'label.coupon.accepted.title': 'Gift balance received',
  'label.coupon.accepted.status': 'Received',
  'label.coupon.rejected.title': 'Gift balance rejected',
  'label.coupon.rejected.status': 'Rejected',
  'label.coupon.reversed.title': 'Gift balance returned',
  'label.coupon.reversed.status': 'Reversed',
  'label.coupon.ready.title': 'Gift balance has been transferred',
  'label.coupon.ready.status': 'Transferred',
  'label.coupon': 'Coupon',
  'label.fav.filter': 'Filter "Favorites',
  'label.fav.ad_new': 'Add a new Favorite',
  'label.automobile.add_new': 'Add new vehicle number',
  'label.fav.suggest.heading': 'Let’s add these to Favorites.',
  'label.fav.suggest.desc': 'Add the following services to "Favorites" to always receive information about debts.',
  'label.automobiles.desc': 'Manage vehicle registration plates here for the convenience of Parqour parking payments.',
  'label.send.money': 'Pul göndər',
  'label.mpay.download': 'Download MPAY',
  'label.modal.login': 'Proceed to login',
  'label.modal.register': 'Proceed to register',
  'label.mpay.downoad.desc': "Via your phone's camera scan the QR code and download",
  'label.change.pin.title': 'Change your PIN ',
  'label.change.pin.new': 'New PIN',
  'label.change.pin.new.reenter': 'Re-enter the New PIN',
  'label.deposit.deactivate.title': 'Deactivate deposit interest rate',
  'label.deposit.deactivate.desc': "If disabled, the monthly deposit interest rate won't be calculated",
  'label.deposit.activate.title': 'Activate deposit interest rate',
  'label.deposit.activate.desc': 'If activated, the monthly deposit interest rate will be calculated on the card',
  'label.transition.source': 'transition source',
  // actions
  'action.forgot_password': 'Forgot password?',
  'action.sign_in': 'Sign In',
  'action.go_to_mpay': 'Switch to MPAY',
  'action.sign_up': 'Sign up',
  'action.send_again': 'Send again',
  'action.confirm': 'Confirm',
  'action.reset_password': 'Reset password',
  'action.continue': 'Continue',
  'action.add_phone_number': 'Add new number',
  'action.back_to_login': 'Back to login',
  'action.top_up': 'Top-up',
  'action.top_up.wallet': 'Top-up',
  'action.top_up.balance': 'Top-up balance',
  'action.wallet_transfer': 'Transfer',
  'action.transfer_to_wallet': 'Transfer',
  'action.repeat': 'Pay again',
  'action.add_favorite': 'Add to favorites',
  'action.added_favorite': 'Added to favorites',
  'action.share': 'Share',
  'action.download': 'Download',
  'action.mpay.download': 'Click here to download',
  'action.look.receipt': 'View receipt',
  'action.transfer.wallet': 'Transfer to wallet',
  'action.call.center': 'Contact customer service',
  'action.all': 'All',
  'action.success': 'Successful',
  'action.failed': 'Failed',
  'action.in_progress': 'In progress',
  'action.edit_label': 'Rename',
  'action.edit': 'Edit',
  'action.delete': 'Delete',
  'action.delete.question': 'Are you sure you want to remove the favorite?',
  'action.delete.automobile': 'Are you sure of deleting the vehicle?',
  'action.logout': 'Are you sure you want to log out?',
  'action.fav.pay_debts': 'Pay debts',
  'action.fav.pay_all_debts': 'Pay all debts',
  'action.delete.autopay': 'Delete auto-payment',
  'action.delete.autopay_desc': 'Are you sure you want to delete {autoPayName}\'s autopay?',
  'action.search.cancel': 'Cancel',
  'action.switch.logout': 'Sign out of other accounts',
  'action.switch.changePasword': 'Change password',
  'action.fav.pay_all_debts_title': 'A shortage of {amount} AZN for payment ',
  'action.fav.pay_all_debts_desc': 'You have  {amount} in your balance. Top up your balance and complete the payment! 🥳',
  'action.pay': 'Pay',
  'action.personal_info': 'Personal information',
  'action.change_password': 'Change password',
  'action.select_language': 'Select language',
  'action.notifications': 'Notifications',
  'action.sign_out': 'Sign out',
  'action.update_info': 'Update information',
  'action.back': 'Back',
  'action.cancel': 'Cancel',
  'action.remove': 'Remove',
  'action.card.remove': 'Delete card',
  'action.save': 'Save',
  'action.do_operation': 'Do operation',
  'action.change': 'Change',
  'action.close': 'Close',
  'action.go_dashboard': 'Back to Home',
  'action.go_automobiles': 'Return to vehicle list',
  'action.home': 'Home',
  'action.favorites': 'Favorites',
  'action.card.order': 'Order',
  'action.more.detail': 'More detail',
  'action.search.autopayment': 'Search in auto payments',
  'action.rename': 'Rename the card',
  'action.account.requisites': 'Account details',
  'action.change.pin': 'Change your PIN',
  'action.reset.pin': 'Reset PIN attempts',
  'action.set.limits': 'Set limits',
  'action.deposit.interest': 'Deposit interest',
  'action.send.money': 'Send money',
  'action.block': 'Block',
  'action.more': 'More',
  'action.soon': 'Soon...',
  'action.extract': 'Export',
  'action.try': 'Get',
  'action.return_automobiles_list': 'Return to list',
  'action.unblock': 'Unblock',
  'action.add.favorites': 'Add to favorites',
  'action.order.confirm': 'Confirm order',
  'action.look_history': 'See history',
  'action.new_automobile': 'New car',
  'action.add_new_automobile': 'Add a new car',
  'action.deposit.deactivate': 'Deactivate',
  'action.deposit.activate': 'Activate',
  'action.limits.table': 'Table of limits',
  'action.limits.increase': 'Increase the limit',

  // filters
  'filters.action': 'Filter',
  'filters.period.this_week': 'Last 1 week',
  'filters.period.last_month': 'Last 30 days',
  'filters.period.last_months': 'Last 90 days',
  'filters.date': 'Date',
  'filters.date.title': 'Select a date',
  'filters.transaction.types': 'Operation type',
  'filters.coupons.types': 'Coupon type',
  'filters.transaction.types.top_up': 'Top-up',
  'filters.transaction.types.transfer': 'Transfer',
  'filters.transaction.types.balance-payment': 'Pay with wallet',
  'filters.transaction.types.card-payment': 'Pay with card',
  'filters.transaction.types.qr_terminal': 'Terminal transaction',
  'filters.coupon.types.received': 'Received',
  'filters.coupon.types.sent': 'You sent',
  'filters.transfers': 'Transfers',
  'filter.category': 'Category',
  // entities

  // validations
  'validation.self_transfer': 'It is not possible to send money to the same account.',
  'validation.sercive_disabled': 'The service is currently unavailable.',
  'validation.required': ' This field cannot be empty.',
  'validation.number': 'Enter a valid number.',
  'validation.pattern': 'The entered information does not match the pattern.',
  'validation.maxlength': 'The required maximum limit ({maxlength}) has been exceeded.',
  'validation.minlength': 'The required minimum limit ({minlength}) is not met.',
  'validation.min': 'Minimum-({min}) AZN',
  'validation.max': 'Maximum-({max}) AZN',
  'validation.amount': 'Enter a valid amount.',
  'validation.error.not-enough-ballance': 'Insufficient balance.',
  'validation.card.number.invalid': 'Enter a valid card number.',
  'validation.card.not.support': 'Transfers are only possible to the specified cards.',
  'validation.contains_digits': 'At least 1 digit (0-9)',
  'validation.contains_lower_letters': 'At least 1 lowercase letter',
  'validation.contains_upper_letters': 'At least 1 uppercase letter',
  'validation.special_symbols': 'At least 1 special character',
  'validation.password_format': 'Password does not meet the requirements.',
  'validation.password_mismatch': 'Passwords do not match.',
  'server.error.internal': 'Internal server error',
  // pages

  // misc
  'misc.auth.sign_in.title': 'Sign in',
  'misc.auth.reset.title': 'Reset password',
  'misc.auth.set_new_password.title': 'Set a new password',
  'misc.auth.without_account': 'Don’t have an account?',
  'misc.auth.login.number': 'Log in with phone number',
  'misc.auth.sign.app': 'Register in the app',
  'misc.auth.with_account': 'Have an account?',
  'misc.auth.without_otp_code': 'Didn’t receive OTP?',
  'misc.auth.retry.qr': 'Click here to update your QR code',
  'misc.auth.account.complete.registration': "Don't have an account? Complete your registration via the app:",
  'misc.auth.account.complete.register': 'Register in the app via QR code',
  'misc.auth.account.complete.login': 'Use the mobile app to sign in to your account.',
  'misc.auth.open.camera': 'Open your phone’s camera.',
  'misc.auth.scan.qr': 'Scan the QR code.',
  'misc.auth.download.app': 'Download the mobile app or register instantly.',
  'misc.auth.scan.qr.register': '2. Scan the QR code with your phone.',
  'misc.auth.download.app.register': '3. Download the “MPAY” mobile app.',
  'misc.auth.account.login.hint_1': 'Log in in seconds—no \n password needed',
  'misc.auth.account.login.hint_2': 'Make instant payments and transfers \n for countless services',
  'misc.auth.account.register.hint_1': 'Sign-up is app-only \n to keep your data safe',
  'misc.auth.account.register.hint_2': 'After registration, easily manage your \n payments and transfers from anywhere',
  'misc.auth.account.login.qr_code': 'Login via QR code',
  'misc.auth.account.login.open_app': 'Launch “MPAY”.',
  'misc.auth.account.login.enter_scan': 'Tap on “Scan”.',
  'misc.auth.account.login.scan_to_login': 'Scan and you’re in!',
  'misc.auth.create.title': 'Create an account via the MPAY app.',
  'misc.auth.register.first': 'Download the MPAY app. 📥',
  'misc.auth.register.second': 'Open the app, sign up and create a new account. 🆕',
  'misc.auth.register.third': 'Log in and enjoy MPAY services. 🚀',
  'misc.auth.modal.login.first': 'Go to the MPAY app—download it if you don’t have it. 📥',
  'misc.auth.modal.login.second': 'Log in—if you don’t have an account, create one. 🆕',
  'misc.auth.modal.login.third': 'Once logged in, enjoy all MPAY services with ease. 🚀',
  'misc.common.or': 'Or',
  'misc.common.or.uppercase': 'Or',
  'misc.common.more': 'More',
  'misc.common.easy': 'Easy',
  'misc.common.sima': 'in the MPAY mobile app',
  'misc.auth.sign_up.title': 'Sign up',
  'misc.auth.sign_up.agreement': 'By registering, you agree to {0} and {1}.',
  'misc.auth.sign_up.agreement.terms': 'Terms of use, rules',
  'misc.auth.sign_up.agreement.privacy': 'Privacy policy',
  'misc.auth.otp.confirm.title': 'Enter the code',
  'misc.auth.otp.label': 'Please enter the <strong>6-digit code</strong> sent to <strong>{phone}</strong>.',
  'misc.auth.asan.label.select_number': 'Select the number to continue',
  'misc.suggest.header': '{category} ödənişin tamamlandı',
  'misc.suggest.desc': 'Digər {category} əməliyyatlarının aparılması üçün “{category}” kateqoriyasına keç.',

  'misc.settings.campaigns.title': 'About services',
  'misc.settings.campaigns.content': 'Get notification about campaigns and services',
  'misc.settings.debt.title': 'Debt payments',
  'misc.settings.debt.content': 'Receive advance notice when payment is due',
  'misc.settings.password.info': 'The new password must be at least 8 characters long and contain at least 1 uppercase letter, lowercase letters and numbers.',
  'misc.settings.notifications.info': 'You can choose the type of notification you want.',
  'misc.settings.notifications.type.app': 'App',
  'misc.settings.notifications.type.email': 'Email',
  'misc.settings.notifications.type.email.address': 'Email address',
  'misc.settings.notifications.type.sms': 'SMS',
  'misc.settings.notifications.empty': 'No notifications yet. Keep exploring!',
  'misc.settings.gender.male': 'Male',
  'misc.settings.gender.female': 'Female',
  'misc.settings.language.az': 'Azerbaijani',
  'misc.settings.language.eng': 'English',
  'misc.settings.language.ru': 'Russian',
  'misc.settings.terms_conditions.terms.title': 'User Terms',
  'misc.settings.terms_conditions.privacy.title': 'Privacy Policy',
  'misc.settings.terms_conditions.tariffs.title': 'Tariffs',
  'misc.settings.profile.personal': 'Personal information',
  'misc.settings.profile.password': 'Password change',
  'misc.settings.profile.password.security': 'Security',
  'misc.settings.profile.password.question': 'Want to change your password?',
  'misc.settings.profile.password.question.desc': 'For security reasons, you can only update your password via {bold}.',
  'misc.settings.profile.password.question.desc.bold': 'the mobile app',
  'misc.settings.profile.password.title1': ' Open the MPAY mobile app',
  'misc.settings.profile.password.desc1': 'Scan the QR code to access the app; if it’s not installed, you’ll be redirected to download it.',
  'misc.settings.profile.password.title2': 'Click on “Settings”',
  'misc.settings.profile.password.desc2': 'Tap “Profile” on the home screen, then go to “Settings”.',
  'misc.settings.profile.password.title3': 'Select “Change password”',
  'misc.settings.profile.password.desc3': 'Follow the prompts to update your password.',
  'misc.settings.profile.password.title': 'Update your password securely in the mobile app',
  'misc.settings.profile.password.desc': 'Scan the QR code to open the app.If it’s not installed, you’ll be taken to the download page.',
  'misc.settings.profile.language': 'Select language',
  'misc.settings.profile.notification': 'Notifications',
  'misc.settings.profile.terms_conditions': 'Terms and Conditions',
  'misc.settings.profile.logout': 'Log out',
  'misc.settings.profile.password-warning': 'The new password must be at least 8 characters long and contain at least 1 uppercase letter, lowercase letters and numbers.',
  'misc.saved.remove.desc': 'All data linked to this card will be deleted.',
  'misc.saved.remove.title': 'Delete card?',
  'misc.saved.update.title': 'Change name',
  'misc.card.update.title': 'Edit card name',
  'misc.saved.update.info': 'Update information',
  'misc.saved.add.title': 'Set a name',
  'misc.saved.index.empty': 'No card found.',
  'misc.support.search.empty': 'No result found for your search',
  'misc.history.automobile.empty': 'No vehicles available.',
  'misc.history.index.empty': 'No operations found',
  'misc.coupon.index.empty': 'No coupons found.',
  'misc.history.search.empty': 'No operation found matching your search.',
  'misc.coupon.search.empty': 'Coupon not found for your search.',
  'misc.history.day.yesterday': 'Yesterday',
  'misc.history.day.today': 'Today',

  'misc.category.search.placeholder': 'Enter service name',
  'misc.category.search.no_results': 'No service found matching your search.',

  'misc.fav.remove.title': 'Delete favourite',
  'misc.fav.index.empty': 'No favorite found matching your search.',
  'misc.fav.search.placeholder': 'Search',
  'misc.fav.input.placeholder': 'Favorite name',
  'misc.fav.debt.last_update': 'Time of last renewal of debts:',
  'misc.fav.debt.request': 'Debt request',
  'misc.fav.debt.request.warning_message': 'Debt inquiry can be done once in 1 hour.',
  'misc.fav.total_amount.title': 'Total amount:',
  'misc.fav.debt_payment.title': 'Pay debt',
  'misc.fav.debt_payment_approve': 'Confirm payment',
  'misc.fav.debt_payment_category': 'Favorites/My Debts',
  'misc.fav.debt.payment.date': 'Payment date',
  'misc.fav.debt.payment.category': 'Service',
  'misc.fav.debt.payment.amount': 'Amount',
  'misc.fav.debt.payment.commission': 'Commission',
  'misc.fav.debt.payment.totalAmount': 'Total amount',
  'misc.fav.debt.payment.source': 'Payment source',
  'misc.fav.autopayment.label': 'Make payment automatically',
  'misc.fav.inactive.title': 'The service is temporarily unavailable',
  'misc.fav.inactive.description': 'Try again when it is active',
  'misc.autopayment.frequency': 'Payment frequency',
  'misc.autopayment.lastPaymentDate': 'Last payment date',
  'misc.autopayment.day': 'Day of the month',
  'misc.autopayment.hour': 'Hour',
  'misc.autopayment.startPaymentDate': 'Start date',
  'misc.autopayment.paymentDate': 'Payment date',
  'misc.limits.monthly.error': 'Remaining limit (monthly): {amount}.',
  'misc.limits.daily.error': 'Remaining limit (daily): {amount}.',
  'misc.limits.description': 'First, we must meet to make more payments and transfers. Due to this, the limit increases.',
  'misc.limits.verified.description': 'Now you can make more payments and transfers because we trust you. 💙',
  'misc.limits.procedures': 'According to the Law on "Payment Services and Payment Systems," these procedures must be followed.',
  'misc.limits.warning.info': 'Only authenticated users are subject to the table of limits.',
  'misc.limits.verified.warning.info': 'Through the limit table, you can view the increased limits.',
  'misc.limits.PAYMENT.title': 'Monthly payment limit',
  'misc.limits.TOP_UP.title': 'Monthly wallet limit',
  'misc.limits.PAYMENT.limit.tooltip': 'This limit applies to transactions made using both the wallet and the card.',
  'misc.limits.TOP_UP.limit.tooltip': 'This limit applies to amounts added through the wallet and the card.',
  'misc.limits.will_update': 'To be updated:',
  'misc.limits.identification': 'Complete identification to increase your limits.',

  'misc.transfer.add_to_fav.title': 'Add to favorites',
  'misc.transfer.to_card.info': 'The card transfer operation applies only to Rabita Bank, Kapital Bank, Bank Respublika, Xalq Bank and ABB Bank cards.',
  'misc.transfer.card': 'Card',
  'misc.transfer.mpay': 'Mpay wallet',

  'misc.transfer.confirm': 'Confirm payment',
  'misc.transfer.confirm.wallet-transfer': 'Transfer to wallet',
  'misc.transfer.confirm.amount': 'Amount',
  'misc.transfer.confirm.amount.currency': 'AZN',
  'misc.transfer.confirm.commission': 'Commission',
  'misc.transfer.confirm.all_amount': 'Total amount',
  'misc.transfer.receipt.account': 'Subscriber code',
  'misc.transfer.receipt.sender': 'Sender',
  'misc.transfer.receipt.receiver': 'Receiver',
  'misc.transfer.receipt.status': 'Transaction status',
  'misc.transfer.receipt.date': 'Transaction date',
  'misc.transaction.number': 'Transaction number',
  'misc.transaction.reversed': 'Amount reversed',
  'misc.terminal.inserted': 'Inserted',
  'misc.terminal.address': 'Address',
  'misc.terminal.paid': 'Paid',
  'misc.transfer.receipt.id': 'Receipt number',
  'misc.transfer.receipt.category': 'Service',
  'misc.transfer.receipt.type': 'Transfer',
  'misc.transfers.commission.warning': 'A 1% commission ({commission} AZN) will be added to this amount.',
  'misc.coupon.receipt.id': 'Coupon number',
  'misc.coupon.receipt.recipient.gift': 'Receiver',
  'misc.coupon.receipt.submitted.date': 'Sending date',
  'misc.coupon.receipt.influencer': 'Influencer code',
  'misc.coupon.receipt.message': 'Wishes',

  'misc.notify.general.success': 'Operation successful!',
  'misc.notify.general.payment_accepted': 'Payment received',
  'misc.notify.personal.success': 'Informations updated successfully',
  'misc.notify.general.error': 'An error occurred.',
  'misc.notify.general.error.desc': 'An error occurred during the operation. Please try again shortly.',
  'misc.notify.general.warning': 'Warning',
  'misc.receipt.code.copy': 'Receipt number copied',
  'misc.notify.bulk.commission.failed': 'A commission may be calculated on this payment',

  'misc.payment.confirm.commission': 'MPAY commission',
  'misc.payment.source': 'Payment source',
  'misc.payment.mpay': 'MPAY wallet:',
  'misc.my_wallet': 'My wallet',
  'misc.second.payment.source': 'Second payment source',

  'misc.app.bar.userfirstname': 'Name',
  'misc.app.bar.account': 'Account',
  'misc.app.search.placeholder': 'Search',
  'misc.app.search.not_found': 'No results found.',
  'misc.main_page': 'Home',
  'misc.go.main_page': 'Back home',
  'misc.autopayment.success.desc': 'Automatic payment was successfully created!',
  'misc.under_development.header': 'Hmm, looks like it\'s time for a technical upgrade!',
  'misc.under_development.contetnt': 'You will be back in MPAY 2.0 payment world soon! You can have a cup of tea and appreciate that waiting time',
  'misc.under_development.download_app': '<b>MPAY 2.0</b> <br/> download app',
  'misc.under_development.follow.fb': 'Follow us <br/> <b>on Instagram</b> ',
  'misc.under_development.follow.ig': 'Follow us <br/> <b>on Facebook</b>',
  'misc.under_development.recommend': 'Or in the meantime',
  'misc.sima.verified': 'Identified',
  'misc.sima.not_verified': 'Unidentified',
  'misc.copied': 'Copied',
  'misc.sima.verified.with': 'Identify with your ID',
  'misc.sima.verified.recommend': 'To increase your limit and access all services, confirm your identification via the <span style="font-weight: 500">"MPAY" mobile application.</span>',
  'misc.app.download.qr': 'Scan the QR code to download the "MPAY" mobile application.',
  'misc.sima.proceed': 'Proceed',
  'misc.ads.guest.title': 'Mobil tətbiqlə daha rahat 🚀  İndi keçid et!',
  'misc.ads.guest.desc': 'Mobil tətbiqlə ödənişlərin statusundan anında xəbərdar ola, yeni xidmətləri tanıya və yaxınına pul köçürə bilərsən.',
  'misc.ads.guest.guide': 'Telefonun kamerası ilə QR kodu skan edərək keçid et',
  'misc.tour.heading': 'Welcome to the world of MPAY! 🤩',
  'misc.tour.message': 'Discover our advantages and enjoy the ease of payments! 💙',
  'misc.tour.message_1': 'You can view and modify notifications from the control panel.',
  'misc.tour.message_2': 'You can top-up your wallet balance at any time.',
  'misc.tour.message_3': 'You can top-up to your friend\'s MPAY wallet.',
  'misc.tour.message_4': 'You can add your payments to "Favorites" and complete them with a single click.',
  'misc.tour.message_5': 'Go to “Automatic Payments” to automate your payments.',
  'misc.tour.message_6': 'You can top up your MPAY wallet as well as your bank card.',
  'misc.tour.next': 'Next',
  'misc.tour.prev': 'Previous',
  'misc.tour.skip': 'Skip',
  'misc.tour.end': 'Close',
  // Sag paneldən ümumi seçilmişlərə baxa bilərsiniz. this text will add above after design finish
};
